import React from "react";
import { Target } from "lucide-react";
import { useGameStateContext } from "../GameStateProvider";

const QuestDisplay: React.FC = () => {
  const { state } = useGameStateContext();
  const { quests } = state;

  return (
    <div className="flex flex-wrap gap-1 text-xs">
      {quests.slice(0, 2).map((quest) => (
        <div
          key={quest.id}
          className="bg-bg-main px-2 py-0.5 rounded-full flex items-center gap-1 border border-border-color"
        >
          <Target size={12} className="text-primary-action" />
          <span className="text-text-secondary">
            {quest.description} <span className="font-semibold text-text-primary">({quest.progress}/{quest.target})</span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default QuestDisplay;
